export default __webpack_public_path__ + "static/media/calling.70c73450.gif";